import type { ReactNode } from 'react';
import { EasterEgg } from './components/EasterEgg';
import { PaperFish } from './components/PaperFish';
import { SteveFollower } from './components/SteveFollower';
import { AquaSkin } from './skins/aqua/AquaSkin';
import { PaintSkin } from './skins/paint/PaintSkin';
import { MatrixSkin } from './skins/matrix/MatrixSkin';
import { PixelSkin } from './skins/pixel/PixelSkin';
import { SaasSkin } from './skins/saas/SaasSkin';
import { SearchSkin } from './skins/search/SearchSkin';
import { SkyblogSkin } from './skins/skyblog/SkyblogSkin';
import { ThreedSkin } from './skins/threed/ThreedSkin';
import { WikiSkin } from './skins/wiki/WikiSkin';
import { XpSkin } from './skins/xp/XpSkin';
import { Y2kSkin } from './skins/y2k/Y2kSkin';
import { useSteve } from './state/context';

/**
 * Racine du site : elle ne fait que résoudre le skin tiré au sort et poser les
 * deux éléments communs (Steve-curseur, easter egg).
 *
 * Aucune commande de changement d'interface n'est visible : on recharge la page
 * pour retomber au hasard, ou on tape le nom de Steve.
 *
 * Les onze skins sont dans le même bundle, volontairement : le tirage a lieu au
 * montage, un découpage de code imposerait un aller-retour réseau
 * supplémentaire sur le chemin critique de chaque visite. Seule la scène 3D y
 * échappe, et c'est documenté dans `vite.config.ts`.
 */
export function App(): ReactNode {
  const { skin } = useSteve();

  return (
    <div className="steve-app">
      {/*
        Deux skins s'en passent : un poisson accroché au curseur casserait le
        sérieux dont dépendent les blagues de Poissonpédia et de Glougle — deux
        pages qui doivent avoir l'air vraies. Le skin 3D l'a récupéré, en
        volume : il ne capte aucun clic, donc il ne gêne pas l'orbite.
      */}
      {skin !== 'wiki' && skin !== 'search' && <SteveFollower />}
      {skin === 'aqua' && <AquaSkin />}
      {skin === 'y2k' && <Y2kSkin />}
      {skin === 'saas' && <SaasSkin />}
      {skin === 'paint' && <PaintSkin />}
      {skin === 'pixel' && <PixelSkin />}
      {skin === 'matrix' && <MatrixSkin />}
      {skin === 'xp' && <XpSkin />}
      {skin === 'skyblog' && <SkyblogSkin />}
      {skin === 'threed' && <ThreedSkin />}
      {skin === 'wiki' && <WikiSkin />}
      {skin === 'search' && <SearchSkin />}
      {/*
        Les deux mots secrets qui laissent une trace : `poisson` colle un
        poisson en papier par-dessus l'interface sans rien interrompre, `orange`
        ouvre l'overlay — qui passe donc au-dessus des poissons.
      */}
      <PaperFish />
      <EasterEgg />
    </div>
  );
}
